import React from "react";

const ProjectDescription = ({ pfrFormData, setPfrFormData }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPfrFormData("projectDescription", {
      [name]: value,
    });
  };

  return (
    <>
      <div className="form-section">
        <h3>Project Description</h3>
        <div className="form-group">
          <label className="required">
            Type of Project including interlinked and interdependent project
          </label>
          <textarea
            type="text"
            name="typeOfProject"
            value={pfrFormData.projectDescription.typeOfProject}
            onChange={handleInputChange}
            placeholder="Enter Type of Project including interlinked and interdependent project"
            required
          />
        </div>
        {/* <div className="form-group">
          <label className="required">Location</label>
        </div> */}
        <div className="form-group">
          <label className="required">Detials of alternate sites</label>
          <input
            type="text"
            name="detailsOfAlternateSites"
            value={pfrFormData.projectDescription.detailsOfAlternateSites}
            onChange={handleInputChange}
            placeholder="Enter Detials of alternate sites"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Size or magnitude of operation</label>
          <textarea
            type="text"
            name="sizeOrMagnitudeOfOperation"
            value={pfrFormData.projectDescription.sizeOrMagnitudeOfOperation}
            onChange={handleInputChange}
            placeholder="Enter Size or magnitude of operation"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">
            Project description with process details
          </label>
          <textarea
            type="text"
            name="projectDescriptionWithProcessDetails"
            value={
              pfrFormData.projectDescription
                .projectDescriptionWithProcessDetails
            }
            onChange={handleInputChange}
            placeholder="Enter Project description with process details"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">
            Resource optimization/recycling and reuse envisaged in the project
          </label>
          <textarea
            type="text"
            name="resourceOptimization"
            value={pfrFormData.projectDescription.resourceOptimization}
            onChange={handleInputChange}
            placeholder="Enter Resource optimization/recycling and reuse envisaged in the project"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">
            Availability of water its source, Energy/Power Requirement and
            source
          </label>
          <textarea
            type="text"
            name="availabilityOfWater"
            value={pfrFormData.projectDescription.availabilityOfWater}
            onChange={handleInputChange}
            placeholder="Enter Availability of water its source, Energy/Power Requirement and source"
            required
          />
        </div>
      </div>
    </>
  );
};

export default ProjectDescription;
